import FlexColumn from '../../layout/flex/column.gjs';
import Super from '../../core/base.gjs';

export default class SpdsModalFlyoutBody extends Super {
  baseClass = 'spds-modal-flyout-body';

  <template>
    <FlexColumn @flex="1" class={{this.classes}} data-test-spds-modal-flyout-body ...attributes>
      {{yield}}
    </FlexColumn>
  </template>
}
